// IMPORTS
// Modules
import { useState, useEffect } from 'react';
import $ from 'jquery';
import { useSearchParams } from 'react-router-dom';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../../../onehivesystems/js/OHSApp';
import OHSWidget from '../../../../onehivesystems/js/OHSWidget';
import OHSMultiTab from '../../../../onehivesystems/js/OHSMultiTab';
import OHSImages from '../../../../onehivesystems/js/OHSImages';
import OHSFilter from '../../../../onehivesystems/js/OHSFilter';
import OHSList, { OHSListDataFormatter } from '../../../../onehivesystems/js/OHSList';
import OHSCRUD from '../../../../onehivesystems/js/OHSCRUD';
// Assets
import './Device.scss';
import Port from './Modules/Port';
import Additions from './Modules/Additions';
import Migrations from './Modules/Migrations';
import Commands from './Modules/Commands';
import ImportExport from './Modules/ImportExport';
import PortTypeImage from './Modules/PortTypeImage';
import { portModel } from './_variables';


// COMPONENT
export default function Device (props) {
   // States and Variables
   const [urlParams] = useSearchParams();
   const deviceID = urlParams.get('id');
   const [prevDeviceID, setPrevDeviceID] = useState(deviceID);
   const [device, setDevice] = useState({
      'name': "Device"
   });
   const [devices, setDevices] = useState(null);
   const [fields, setFields] = useState(null);
   const [commands, setCommands] = useState(null);
   const [portTemplates, setPortTemplates] = useState(null);
   const [ports, setPorts] = useState(null);
   const [portPopups, setPortPopups] = useState({});
   const [images, setImages] = useState(null);
   const [commandResults, setCommandResults] = useState(null);

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("OnePort | Device");  // set page title
      getDevice();
      getDevices();
      getFields();
      getPortTemplates();
      getImages();
   }, []);

   // Listeners
   useEffect(function () {
      if (deviceID !== prevDeviceID) {
         window.location.reload(); // reload the whole page if switched to different device
      }
   }, [urlParams]);
   useEffect(function () {
      if (device.collection_id !== null && device.collection_id !== undefined) {
         getCommands();
      }
   }, [device]);
   useEffect(function () {
      if (fields !== null && fields !== undefined) {
         getPorts(); // get ports after fields are loaded in
      }
   }, [fields]);

   // Functions
   const getDevice = function () {
      OHSCRUD({
         url: '/v1/oneport/devices/' + deviceID,
         method: 'GET',
         success: function (data) {
            setDevice(data[0]);
         }
      });
   }
   const getDevices = function () {
      OHSCRUD({
         url: '/v1/oneport/devices',
         method: 'GET',
         success: function (data) {
            setDevices(OHSListDataFormatter(data));
         }
      });
   }
   const getFields = function () {
      OHSCRUD({
         url: '/v1/oneport/fields',
         method: 'GET',
         success: function (data) {
            // Dynamically Build Port Model
            data.forEach(function (field, i) {
               portModel[field.id] = {
                  'title': field.name,
                  'display': Boolean(Number(field.value_in_list))
               };
            });

            // Set Data
            setFields(data);
         },
         setOHSLoading: props.onehive.setLoading
      });
   }
   const getCommands = function () {
      OHSCRUD({
         url: '/v1/oneport/commands/collection/' + device.collection_id,
         method: 'GET',
         success: function (data) {
            setCommands(OHSListDataFormatter(data))
         }
      });
   }
   const getPortTemplates = function () {
      OHSCRUD({
         url: '/v1/oneport/porttemplates',
         method: 'GET',
         success: function (data) {
            setPortTemplates(OHSListDataFormatter(data));
         }
      });
   }
   const getPorts = function () {
      OHSCRUD({
         url: '/v1/oneport/ports/' + deviceID,
         method: 'GET',
         success: function (data) {
            setPorts(OHSListDataFormatter(data, portModel));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const getImages = function () {
      OHSCRUD({
         url: '/v1/oneport/files/list/' + deviceID,
         method: 'GET',
         success: function (data) {
            setImages(data);
         },
         setOHSPopup: props.onehive.setPopup
      });
   }
   const uploadImage = function (inputID) {
      // Build Form with Image
      const data = new FormData();
      data.append('file', $('#' + inputID)[0].files[0]);

      // Perform API Call
      OHSCRUD({
         url: '/v1/oneport/files/' + deviceID,
         method: 'POST',
         payload: data,
         file: true,
         success: function (data) {
            getImages();
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const updateImage = function (id, inputID) {
      // Build Form with Image
      const data = new FormData();
      data.append('file', $('#' + inputID)[0].files[0]);

      // Perform API Call
      OHSCRUD({
         url: '/v1/oneport/files/' + id,
         method: 'PUT',
         payload: data,
         file: true,
         success: function (data) {
            getImages();
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         showSuccessPopup: false,
         confirmMessage: "Are you sure you wish to update this existing image?"
      });
   }
   const deleteImage = function (id, index) {
      OHSCRUD({
         url: '/v1/oneport/files/' + id,
         method: 'DELETE',
         success: function (data) {
            var temp = images;
            temp.splice(index, 1);
            setImages(temp);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         showSuccessPopup: true,
         confirmMessage: "Are you sure you wish to delete this image?"
      });
   }
   const reorderPorts = function (order) {
      OHSCRUD({
         url: '/v1/oneport/ports/reorder',
         method: 'PUT',
         payload: order,
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const getPortStatus = function (port) {
      let status = "available";
      if (port.unusable.value == 1) {
         status = "broken";
      } else if ((fields) && (fields.length > 0)) {
         fields.map(function (field, i) {
            if (field.type == "checkbox") {
               if ((field.use_for_availability == 1) && (port[field.id].value == 1)) {
                  status = "patched";
               }
            } else if (field.use_for_availability == 1) {
               if ((port[field.id].value !== "") && (port[field.id].value !== null) && (port[field.id].value !== undefined)) {
                  status = "patched";
               }
            }
         });
      }
      return status;
   }
   const showPort = function (index) {
      setPortPopups({...portPopups, [index]: true});
   }

   // Component
   return (
      <div className="oneport-device">
         <OHSAppHeader onehive={props.onehive} title={device.name} help="https://www.onehivesystems.com/documentation/oneport/device" />
         <OHSAppBody onehive={props.onehive}>
            <OHSWidget onehive={props.onehive} title="Port Diagram">
               <div className='oneport-device-portdiagram'>
                  <div className='oneport-device-portdiagram-toprow'>
                     {ports && ports.length > 0 && ports.map(function (port, i) {
                        if (!(i % 2)) {
                           return (
                              <div key={`oneport-device-portdiagram-port-${i}`} className={getPortStatus(port) === "broken" ? 'oneport-device-portdiagram-port oneport-device-portdiagram-port-broken' : getPortStatus(port) === "patched" ? 'oneport-device-portdiagram-port oneport-device-portdiagram-port-patched' : 'oneport-device-portdiagram-port'} onClick={() => {showPort(i);}}>
                                 <PortTypeImage onehive={props.onehive} value={port.port_type.value} />
                                 <p>{port.name.value}</p>
                              </div>
                           );
                        }
                     })}
                  </div>
                  <div className='oneport-device-portdiagram-bottomrow'>
                     {ports && ports.length > 0 && ports.map(function (port, i) {
                        if (i % 2) {
                           return (
                              <div key={`oneport-device-portdiagram-port-${i}`} className={getPortStatus(port) === "broken" ? 'oneport-device-portdiagram-port oneport-device-portdiagram-port-broken' : getPortStatus(port) === "patched" ? 'oneport-device-portdiagram-port oneport-device-portdiagram-port-patched' : 'oneport-device-portdiagram-port'} onClick={() => {showPort(i);}}>
                                 <PortTypeImage onehive={props.onehive} value={port.port_type.value} />
                                 <p>{port.name.value}</p>
                              </div>
                           );
                        }
                     })}
                  </div>
               </div>
            </OHSWidget>
            <OHSMultiTab onehive={props.onehive} id="multitab1" content={[
               {
                  title: "Images",
                  content: <OHSImages onehive={props.onehive} images={images} setImages={setImages} upload={uploadImage} update={updateImage} delete={deleteImage} />
               },
               {
                  title: "Additions",
                  content: <Additions onehive={props.onehive} parent={{
                     deviceID: deviceID,
                     getPorts: getPorts
                  }} />
               },
               {
                  title: "Migrations",
                  content: <Migrations onehive={props.onehive} parent={{
                     ports: ports,
                     fields: fields,
                     getPorts: getPorts
                  }} />
               },
               {
                  title: "Commands",
                  content: <Commands onehive={props.onehive} parent={{
                     device: device,
                     deviceID: deviceID,
                     ports: ports,
                     commands: commands,
                     commandResults: commandResults,
                     setCommandResults: setCommandResults
                  }} />
               },
               {
                  title: "Import/Export",
                  content: <ImportExport onehive={props.onehive} parent={{
                     deviceID: deviceID,
                     getPorts: getPorts
                  }} />
               }
            ]} />
            <OHSFilter onehive={props.onehive} title="Filter Ports" container='oneport-ports-list' />
            <OHSWidget onehive={props.onehive} id='oneport-ports-list' title="List of Ports">
               <OHSList onehive={props.onehive} content={ports} popups={portPopups} setPopups={setPortPopups} enableDragging={true} handleDragging={reorderPorts} template={
                  <Port onehive={props.onehive} parent={{
                     devices: devices,
                     setDevices: setDevices,
                     fields: fields,
                     setFields: setFields,
                     portTemplates: portTemplates,
                     setPortTemplates: setPortTemplates,
                     ports: ports,
                     setPorts: setPorts,
                     getPortStatus: getPortStatus
                  }} />
               } />
            </OHSWidget>
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}